import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { catchErr, showInputError } from 'src/app/shared/utils';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-remover-cadastro',
    templateUrl: './remover-cadastro.component.html',
    standalone: false
})
export class RemoverCadastroComponent {

    loading: boolean = false;
    showInputError = showInputError;

    constructor(
        private authService: AuthService,
        private router: Router,
        private snackBar: MatSnackBar
    ) { }

    removerCadastro(form: NgForm) {
        this.loading = true;
        const { email, nomeCompleto } = form.form.value;

        this.authService.removerCadastro(email, nomeCompleto).subscribe({
            next: () => {
                this.snackBar.open('Solicitação de remoção de cadastro enviada com sucesso!', '✕', { panelClass: ['success'] });
                form.resetForm();
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }
}
